
import React, { useState, useEffect } from "react";
import axios from "axios";
import { getBaseUrl } from "../api";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import Header from "./Header";
import Navbar1 from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useUser } from "./context/UserContext";

function Profile() {
  const [crn, setCrn] = useState(null);
  const [error, setError] = useState("");
  const { loggedInUser } = useUser();
  const navigate = useNavigate();
  const [mciIdExists, setMciIdExists] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [fetchedFileName, setFetchedFileName] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [profileImageFileName, setProfileImageFileName] = useState(""); // NEW
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState(""); 
  const baseUrl = getBaseUrl();
  const [formData, setFormData] = useState({
    name: "",
    registrationNumber: "",
    contactNumber: ""
  });

  useEffect(() => {
    axios
      .post(`https://${baseUrl}/request`, { object: "crn", qdn: "diabrain" })
      .then((response) => {
        if (response.data.crn) setCrn(response.data.crn);
        else setError("Failed to fetch CRN. Please try again later.");
      })
      .catch((err) => {
        console.error("Error fetching CRN:", err);
        setError("Failed to fetch CRN. Please try again later.");
      });
  }, []);

  useEffect(() => {
    if (!loggedInUser || !crn) return;

    axios
      .post(`https://${baseUrl}/request`, {
        crn,
        user_id: loggedInUser,
        object: "profile",
        action: "R",
      })
      .then((response) => {
        if (response.data?.response?.length > 0) {
          const profile = response.data.response[0];
          setFormData({
            name: profile.fullname || "",
            registrationNumber: profile.mci_id || "",
            contactNumber: profile.mobile_number || "",
          });

          if (profile.mci_id) {
            setMciIdExists(true);
            // setIsSubmitted(true);
            
            axios
            .post(`https://${baseUrl}/request`, {
              crn,
              user_id: loggedInUser,
              object: "users",
              action: "R",
            })
            .then((res) => {
              const verifiedStatus = res.data?.response?.[0]?.verified;
              if (verifiedStatus === "Yes") {
                setIsSubmitted(true); // ✅ Only set if verified is Y
              }
            })
            .catch((err) => {
              console.error("Error checking verified status:", err);
            });


          }
        }
      })
      .catch((error) => {
        console.error("Error fetching profile details:", error);
      });

    axios
      .post(`https://${baseUrl}/request`, {
        crn,
        user: loggedInUser,
        object: "repos",
        action: "R"
      })
      .then((res) => {
        if (res.data?.response) {
          const certFile = res.data.response.find((item) => item.rep_type?.toLowerCase() === "cert");
          const picFile = res.data.response.find((item) => item.rep_type?.toLowerCase() === "profilepic");

          if (certFile?.external_name?.startsWith(`https://${baseUrl}`)) {
            setFilePreview(certFile.external_name);
            setFetchedFileName(certFile.name || "Uploaded Certificate");
          }

          if (picFile?.external_name?.startsWith(`https://${baseUrl}`)) {
            setProfileImagePreview(picFile.external_name);
            if (picFile.name) setProfileImageFileName(picFile.name); // <-- NEW
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching files from repos:", err);
      });
  }, [crn, loggedInUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contactNumber") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length <= 10) {
        setFormData({ ...formData, [name]: digitsOnly });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (selectedFile && allowedTypes.includes(selectedFile.type)) {
      setFile(selectedFile);
      setFilePreview(URL.createObjectURL(selectedFile));
      setFetchedFileName("");
      setFormErrors((prevErrors) => ({ ...prevErrors, file: "" }));
    } else {
      setFile(null);
      setFilePreview(null);
      setFetchedFileName("");
      setFormErrors((prevErrors) => ({ ...prevErrors, file: "Only JPG, JPEG, or PNG files are allowed." }));
    }
  };

  const handleProfileImageChange = (e) => {
    const selectedFile = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (selectedFile && allowedTypes.includes(selectedFile.type)) {
      setProfileImage(selectedFile);
      setProfileImagePreview(URL.createObjectURL(selectedFile));
      setProfileImageFileName(selectedFile.name); // <-- NEW
      setFormErrors((prevErrors) => ({ ...prevErrors, profileImage: "" }));
    } else {
      setProfileImage(null);
      setProfileImagePreview(null);
      setProfileImageFileName(""); // <-- NEW
      setFormErrors((prevErrors) => ({ ...prevErrors, profileImage: "Only JPG, JPEG, or PNG files are allowed." }));
    }
  };

  const cleanFileName = (name) => {
    const ref = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.";
    return name.split("").filter(ch => ref.includes(ch)).join("");
  };

  const getFileExt = (filename) => filename.split('.').pop();

  const uploadFile = (dt, name, enc, fileBuf) => {
    return new Promise((resolve, reject) => {
      const xmlHttp = new XMLHttpRequest();
      xmlHttp.open("POST",`https://${baseUrl}/upload`, true);
      xmlHttp.setRequestHeader("x-dt", dt);
      xmlHttp.setRequestHeader("x-name", name);
      xmlHttp.setRequestHeader("x-enc", enc);
      xmlHttp.onload = () => {
        if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
          resolve(xmlHttp.responseText);
        } else {
          reject("Upload failed with " + xmlHttp.statusText);
        }
      };
      xmlHttp.onerror = () => reject("Upload exception occurred");
      xmlHttp.send(fileBuf);
    });
  };

  const handleImageClick = (src) => {
    setModalImageSrc(src);
    setShowImageModal(true);
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name.trim()) errors.name = "Name is required.";
    if (!formData.registrationNumber.trim()) errors.registrationNumber = "Doctor Registration Number is required.";
    if (!formData.contactNumber.trim()) errors.contactNumber = "Contact number is required.";
    else if (!/^\d{10}$/.test(formData.contactNumber)) errors.contactNumber = "Contact number must be exactly 10 digits.";
    if (!mciIdExists && !file) errors.file = "Doctor Registration Certificate is required.";
    if (!profileImage && !profileImagePreview) errors.profileImage = "Profile photo is required.";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      let nowDate = new Date();
      let nowmm = nowDate.getMonth() + 1;
      let strmm = nowmm < 10 ? "0" + nowmm : nowmm.toString();
      let yymm = nowDate.getFullYear().toString() + strmm;
      const userName = loggedInUser;

      if (profileImage) {
        const profileType = "ProfilePic";
        const profileExt = getFileExt(profileImage.name);
        const profileInternalName = `${userName.replace(/@/g, "_")}_${profileType}_${nowDate.getTime()}.${profileExt}`;
        const cleanProfileName = cleanFileName(profileInternalName);
        const arrayBuffer = await profileImage.arrayBuffer();
        const fileBuf = new Uint8Array(arrayBuffer);

        await uploadFile(yymm, cleanProfileName, "bin", fileBuf);

        const externalProfileUrl = `https://${baseUrl}/docs/${yymm}/${cleanProfileName}`;

        await axios.post(`https://${baseUrl}/request`, {
          crn,
          user: userName,
          rep_type: profileType,
          name: profileImage.name,
          udt: new Date().toISOString().split("T")[0],
          mode: "Upload",
          internal_name: cleanProfileName,
          yyyymm: yymm,
          status: "N",
          last_update_user: userName,
          external_name: externalProfileUrl,
          action: "A",
          object: "repos",
        });
      }

      if (!mciIdExists && file) {
        const myType = "Cert";
        const myExt = getFileExt(file.name);
        const intName = `${userName.replace(/@/g, "_")}_${myType.replace(/ /g, "_")}_${nowDate.getTime()}.${myExt}`;
        const cleanIntName = cleanFileName(intName);
        const arrayBuffer = await file.arrayBuffer();
        const fileBuf = new Uint8Array(arrayBuffer);

        await uploadFile(yymm, cleanIntName, "bin", fileBuf);

        const externalUrl = `https://${baseUrl}/docs/${yymm}/${cleanIntName}`;

        await axios.post(`https://${baseUrl}/request`, {
          crn,
          user: loggedInUser,
          rep_type: myType,
          name: file.name,
          udt: new Date().toISOString().split("T")[0],
          mode: "Upload",
          internal_name: cleanIntName,
          yyyymm: yymm,
          status: "N",
          last_update_user: loggedInUser,
          external_name: externalUrl,
          action: "A",
          object: "repos",
        });
      }

      await axios.post(`https://${baseUrl}/request`, {
        crn,
        user_id: loggedInUser,
        fullname: formData.name,
        mobile_number: formData.contactNumber,
        mci_id: formData.registrationNumber,
        object: "profile",
        action: mciIdExists ? "U" : "A",
      });


      
      await axios.post(`https://${baseUrl}/request`, {
        object: "email",
        action: "A",
      });

      alert(mciIdExists ? "Details updated successfully!" : "Details submitted successfully!");
      // setIsSubmitted(true);
      navigate("/landing");
      
    } catch (error) {
      console.error("Error during upload or submission:", error);
      alert("Failed to submit details. Please try again.");
    }
  };

  
  return (
    <>
      <Header />
      <Navbar1 />
      <Container className="mt-4">
        <Row className="justify-content-center">
          <Col lg={6} xs={12}>
            <h2 className="mb-4 text-center">Profile Section</h2>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Doctor Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  isInvalid={!!formErrors.name}
                  readOnly={isSubmitted}
                />
                <Form.Control.Feedback type="invalid">{formErrors.name}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Doctor Registration Number</Form.Label>
                <Form.Control
                  type="text"
                  name="registrationNumber"
                  placeholder="Enter registration number"
                  value={formData.registrationNumber}
                  onChange={handleChange}
                  isInvalid={!!formErrors.registrationNumber}
                  readOnly={isSubmitted}
                />
                <Form.Control.Feedback type="invalid">{formErrors.registrationNumber}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Contact Number (Preferably WhatsApp)</Form.Label>
                <Form.Control
                  type="text"
                  name="contactNumber"
                  placeholder="Enter your 10-digit WhatsApp number"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  isInvalid={!!formErrors.contactNumber}
                  readOnly={isSubmitted}
                />
                <Form.Control.Feedback type="invalid">{formErrors.contactNumber}</Form.Control.Feedback>
              </Form.Group>

            

              {!isSubmitted && (
                <>
                  <Form.Group className="mb-3 mt-4">
                    <Form.Label>Upload Profile Photo</Form.Label>
                    <Form.Control
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleProfileImageChange}
                      isInvalid={!!formErrors.profileImage}
                    />
                    <Form.Text className="text-muted">Allowed file types: JPG, JPEG, PNG</Form.Text>
                    <Form.Control.Feedback type="invalid">{formErrors.profileImage}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Doctor Registration Certificate</Form.Label>
                    <Form.Control
                      id="file-upload"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleFileChange}
                      isInvalid={!!formErrors.file}
                    />
                    <Form.Text className="text-muted">Allowed file types: JPG, JPEG, PNG</Form.Text>
                    <Form.Control.Feedback type="invalid">{formErrors.file}</Form.Control.Feedback>
                  </Form.Group>

                  {/* <div className="d-flex justify-content-end">
                    <Button variant="primary" onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div> */}

                  <div className="d-flex justify-content-between">
                      <Button variant="danger" onClick={() => navigate("/landing")}>
                        Skip
                      </Button>
                      <Button variant="primary" onClick={handleSubmit}>
                        Submit
                      </Button>
                  </div>

                </>
              )}
            </Form>
          </Col>
        </Row>
        <Row>
          <Col lg={6} xs={6}>
          {profileImagePreview && (
                <div className="mt-2 text-center">
                  <strong>Profile</strong><br />
                  <img
                    src={profileImagePreview}
                    alt="Profile"
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "8px",
                      objectFit: "contain",
                      marginTop: "10px"
                    }}
                    onClick={() => handleImageClick(profileImagePreview)}
                  />
                </div>
              )}

              {profileImageFileName && (
                <div className="text-center mt-2">
                  <strong style={{ color: "red" }}>File Name: <span>{profileImageFileName}</span></strong>
                </div>
              )}
            </Col>
            <Col lg={6} xs={6}>
              {filePreview && (
                <div className=" mt-2 text-center">
                  <strong>Registration Certificate</strong><br />
                  <img
                    src={filePreview}
                    alt="Certificate Preview"
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "8px",
                      objectFit: "contain",
                      marginTop: "10px"
                    }}
                    onClick={() => handleImageClick(filePreview)}
                  />
                </div>
              )}

              {fetchedFileName && (
                <div className="text-center">
                  <strong style={{ color: "red" }}>File Name: <span>{fetchedFileName}</span></strong>
                </div>
              )}
          </Col>
        </Row>
      </Container>
      {/* image show full screen */}
      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered size="xl">
        <Modal.Body className="p-0">
          <img src={modalImageSrc} alt="Full View" style={{ width: "100%", height: "auto", objectFit: "contain" }} />
        </Modal.Body>
      </Modal>

    </>
  );
}

export default Profile;
